import { BlipApi } from './BlipApi';

export class PipelineApi {
  private static readonly PORTAL_POSTMASTER = 'postmaster@portal.blip.ai';
  private static readonly MSGING_POSTMASTER = 'postmaster@msging.net';

  // HTTP Methods constants
  private static readonly HTTP_METHODS = {
    GET: 'get',
    SET: 'set', 
    MERGE: 'merge',
    DELETE: 'delete',
  } as const;

  //#region Applications

  public static async getApplicationsAsync(tenantId: string): Promise<any> {
    const applications = await BlipApi.sendCommand({
      to: this.PORTAL_POSTMASTER,
      method: this.HTTP_METHODS.GET,
      uri: `/tenants/${tenantId}/applications`,
    });
    return applications.response || applications;
  }


  public static async deleteApplicationAsync(pipelineId: string): Promise<void> {
    await BlipApi.sendCommand({
      to: this.PORTAL_POSTMASTER,
      method: this.HTTP_METHODS.DELETE,
      uri: `/applications/${pipelineId}@msging.net?messagingHubCommandWithDelegation=true`,
    });
  }


  public static async getBuilderWorkingConfigurationAsync(pipelineId: string, localNode?: string, userEmail?: string): Promise<any> {
    const ppValue = localNode ? `${localNode}` : undefined;
    
    const configuration = await BlipApi.sendCommand({
      method: this.HTTP_METHODS.GET,
      uri: '/buckets/blip_portal:builder_working_configuration?$take=100',
      to: this.MSGING_POSTMASTER,
      from: `${pipelineId}@msging.net`,
      pp: ppValue,
      metadata: {
        'blip_portal.email': userEmail || 'unknown@blip.ai',
        'server.shouldStore': 'true',
      },
    });
    return configuration.response || configuration;
  }
}